import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';
import type { IIdAckResponse } from '../ack-schema';
import { idAckResponseSchema } from '../ack-schema';

export async function deletePersonPhotoApi(
  personId: number,
  photoId: number,
): Promise<IValidatedResponse<IIdAckResponse>> {
  return deleteRequest<IIdAckResponse>({
    path: `/sys/people/v1/${personId}/photos/${photoId}`,
    schema: idAckResponseSchema,
  });
}
